module.exports = __webpack_public_path__ + "static/matches-cyan-201d6319cdab1186eeac32d34bfe74a9.png";